import { render, staticRenderFns } from "./ListRender.vue?vue&type=template&id=1b4ce7cb&"
import script from "./ListRender.vue?vue&type=script&lang=ts&"
export * from "./ListRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports